import {
  FETCH_DASHBOARD_ANALYTICS,
  FETCH_DASHBOARD_ANALYTICS_SUCCESS,
  FETCH_DASHBOARD_ANALYTICS_DAYWISE,
  FETCH_DASHBOARD_ANALYTICS_FAIL,
  FETCH_DASHBOARD_ANALYTICS_SKIP,
  CLEAR_DASHBOARD_ANALYTICS,
} from '../actions/dashboard';
import { trimDashboardCache } from '../../utils/dashboardAnalytics';

const initialState = {
  analysisData: null,
  dayWiseData: {},
  loading: false,
  dayWiseLoading: false,
  error: null,
  activeCacheKey: null,
  fromCache: false,
  lastFetchedAt: null,
  cache: {},
  cacheKeys: [],
};

export default function dashboardReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_DASHBOARD_ANALYTICS: {
      const forceRefresh = Boolean(action.payload?.forceRefresh);
      const hasMainData = Boolean(state.analysisData);
      const hasDayWise =
        state.dayWiseData && Object.keys(state.dayWiseData).length > 0;

      return {
        ...state,
        loading: forceRefresh || !hasMainData,
        dayWiseLoading:
          Boolean(action.payload?.isMultiDay) &&
          (forceRefresh || !hasDayWise),
        error: null,
      };
    }

    case FETCH_DASHBOARD_ANALYTICS_SKIP:
      return {
        ...state,
        loading: false,
        dayWiseLoading: false,
      };

    case FETCH_DASHBOARD_ANALYTICS_SUCCESS: {
      const {
        cacheKey,
        analysisData,
        dayWiseData,
        fromCache,
        fetchedAt,
        isMultiDay,
        alreadyActive = false,
      } = action.payload;

      const nextDayWise = dayWiseData || {};

      if (
        alreadyActive &&
        state.activeCacheKey === cacheKey &&
        state.analysisData &&
        (!isMultiDay || (state.dayWiseData && Object.keys(state.dayWiseData).length > 0))
      ) {
        return {
          ...state,
          loading: false,
          dayWiseLoading: false,
          fromCache: true,
        };
      }

      const existingIndex = state.cacheKeys.indexOf(cacheKey);
      const nextKeys =
        existingIndex === -1
          ? [...state.cacheKeys, cacheKey]
          : [...state.cacheKeys.filter((key) => key !== cacheKey), cacheKey];

      const nextCache = {
        ...state.cache,
        [cacheKey]: {
          analysisData,
          dayWiseData: nextDayWise,
          fetchedAt,
          isMultiDay: Boolean(isMultiDay),
        },
      };

      const trimmed = trimDashboardCache(nextCache, nextKeys);

      return {
        ...state,
        loading: false,
        dayWiseLoading: false,
        error: null,
        analysisData,
        dayWiseData: nextDayWise,
        activeCacheKey: cacheKey,
        fromCache: Boolean(fromCache),
        lastFetchedAt: fetchedAt,
        cache: trimmed.cache,
        cacheKeys: trimmed.cacheKeys,
      };
    }

    case FETCH_DASHBOARD_ANALYTICS_DAYWISE: {
      const { cacheKey, dayWiseData, fetchedAt } = action.payload;
      const cached = state.cache[cacheKey];

      const nextCache = {
        ...state.cache,
        [cacheKey]: {
          ...(cached || {}),
          analysisData: cached?.analysisData ?? state.analysisData,
          dayWiseData: dayWiseData || {},
          fetchedAt: fetchedAt || cached?.fetchedAt || Date.now(),
          isMultiDay: true,
        },
      };

      return {
        ...state,
        dayWiseLoading: false,
        dayWiseData: dayWiseData || {},
        cache: nextCache,
      };
    }

    case FETCH_DASHBOARD_ANALYTICS_FAIL:
      return {
        ...state,
        loading: false,
        dayWiseLoading: false,
        error: action.payload || 'Error fetching dashboard analytics',
      };

    case CLEAR_DASHBOARD_ANALYTICS:
      return {
        ...initialState,
        cache: state.cache,
        cacheKeys: state.cacheKeys,
      };

    default:
      return state;
  }
}
